import { Fragment, useMemo } from 'react';
import { VscLoading } from 'react-icons/vsc';
import PromptTemplateTable from './PromptTemplateTable';
import Pagination from '../Admin/Pagination';

const PromptTemplateTableContainer = ({
    loading,
    handleUpdatePromptTemplate,
    fetchOnAction,
    data = {},
    currentPage,
    onPageChanged,
}) => {
    const promptTemplates = useMemo(() => data?.results || [], [data]);
    if (loading) {
        return (
            <h4 className="text-center">
                <VscLoading className="spin" fontSize="42" />
            </h4>
        );
    }
    return (
        <Fragment>
            {promptTemplates && promptTemplates.length ? (
                <Fragment>
                    <PromptTemplateTable
                        page={data?.page || 1}
                        limit={data?.limit || 10}
                        promptTemplates={promptTemplates}
                        onEdit={handleUpdatePromptTemplate}
                        onArchive={fetchOnAction}
                    />
                    {data.totalResults ? (
                        <div className="m-4">
                            <Pagination
                                pageNo={currentPage}
                                totalRecords={data.totalResults}
                                pageLimit={10}
                                pageNeighbours={1}
                                onPageChanged={onPageChanged}
                            />
                        </div>
                    ) : null}
                </Fragment>
            ) : (
                <div className="text-center mt-4">
                    <h2 className="mt-4 mb-4">No prompt templates found.</h2>
                    <div className="mt-4">
                        <p className="text-muted mb-3 mt-3">
                            Create reusable prompt templates with shortcut keywords for your team to use AI assistants
                            efficiently with /bob and /quinn commands.
                        </p>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default PromptTemplateTableContainer;
